export const formatRut = (rut) => {
  if (!rut) return rut;
  const cleanRut = rut.replace(/[^0-9kK]/g, '');
  if (cleanRut.length <= 1) return cleanRut;
  const body = cleanRut.slice(0, -1);
  const dv = cleanRut.slice(-1);
  return `${body.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}-${dv}`;
};